/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateSeryRiderInfo = /* GraphQL */ `
  subscription OnCreateSeryRiderInfo(
    $id: String
    $storeSeq: String
    $phone: String
    $pw: String
    $riderName: String
  ) {
    onCreateSeryRiderInfo(
      id: $id
      storeSeq: $storeSeq
      phone: $phone
      pw: $pw
      riderName: $riderName
    ) {
      id
      storeSeq
      phone
      pw
      riderName
      useFlag
      gcmKey
    }
  }
`;
export const onUpdateSeryRiderInfo = /* GraphQL */ `
  subscription OnUpdateSeryRiderInfo(
    $id: String
    $storeSeq: String
    $phone: String
    $pw: String
    $riderName: String
  ) {
    onUpdateSeryRiderInfo(
      id: $id
      storeSeq: $storeSeq
      phone: $phone
      pw: $pw
      riderName: $riderName
    ) {
      id
      storeSeq
      phone
      pw
      riderName
      useFlag
      gcmKey
    }
  }
`;
export const onDeleteSeryRiderInfo = /* GraphQL */ `
  subscription OnDeleteSeryRiderInfo(
    $id: String
    $storeSeq: String
    $phone: String
    $pw: String
    $riderName: String
  ) {
    onDeleteSeryRiderInfo(
      id: $id
      storeSeq: $storeSeq
      phone: $phone
      pw: $pw
      riderName: $riderName
    ) {
      id
      storeSeq
      phone
      pw
      riderName
      useFlag
      gcmKey
    }
  }
`;
export const onCreateSeryOrderInfos = /* GraphQL */ `
  subscription OnCreateSeryOrderInfos(
    $orderSeq: String
    $storeSeq: String
    $userSeq: Int
    $deliveryInfo: String
    $orderNo: String
  ) {
    onCreateSeryOrderInfos(
      orderSeq: $orderSeq
      storeSeq: $storeSeq
      userSeq: $userSeq
      deliveryInfo: $deliveryInfo
      orderNo: $orderNo
    ) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const onCreateSeryOrderInfo = /* GraphQL */ `
  subscription OnCreateSeryOrderInfo(
    $orderSeq: String
    $storeSeq: String
    $userSeq: Int
    $deliveryInfo: String
    $orderNo: String
  ) {
    onCreateSeryOrderInfo(
      orderSeq: $orderSeq
      storeSeq: $storeSeq
      userSeq: $userSeq
      deliveryInfo: $deliveryInfo
      orderNo: $orderNo
    ) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
    }
  }
`;
export const onAllCreateSeryOrderInfo = /* GraphQL */ `
  subscription OnAllCreateSeryOrderInfo {
    onAllCreateSeryOrderInfo {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
    }
  }
`;
export const onAllUpdateSeryOrderInfo = /* GraphQL */ `
  subscription OnAllUpdateSeryOrderInfo {
    onAllUpdateSeryOrderInfo {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const onCreateSeryOrderInfo2 = /* GraphQL */ `
  subscription OnCreateSeryOrderInfo2($storeSeq: String) {
    onCreateSeryOrderInfo2(storeSeq: $storeSeq) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
    }
  }
`;
export const onUpdateSeryOrderInfo = /* GraphQL */ `
  subscription OnUpdateSeryOrderInfo(
    $orderSeq: String
    $storeSeq: String
    $userSeq: Int
    $deliveryInfo: String
    $orderNo: String
  ) {
    onUpdateSeryOrderInfo(
      orderSeq: $orderSeq
      storeSeq: $storeSeq
      userSeq: $userSeq
      deliveryInfo: $deliveryInfo
      orderNo: $orderNo
    ) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const onUpdateSeryOrderInfo2 = /* GraphQL */ `
  subscription OnUpdateSeryOrderInfo2($storeSeq: String) {
    onUpdateSeryOrderInfo2(storeSeq: $storeSeq) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const onUpdateSeryOrderInfo3 = /* GraphQL */ `
  subscription OnUpdateSeryOrderInfo3($userSeq: Int) {
    onUpdateSeryOrderInfo3(userSeq: $userSeq) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const onDeleteSeryOrderInfo = /* GraphQL */ `
  subscription OnDeleteSeryOrderInfo(
    $orderSeq: String
    $storeSeq: String
    $userSeq: Int
    $deliveryInfo: String
    $orderNo: String
  ) {
    onDeleteSeryOrderInfo(
      orderSeq: $orderSeq
      storeSeq: $storeSeq
      userSeq: $userSeq
      deliveryInfo: $deliveryInfo
      orderNo: $orderNo
    ) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const onCreateSeryNoti = /* GraphQL */ `
  subscription OnCreateSeryNoti(
    $REGDATE: String
    $USEFLAG: String
    $NOTI_TITLE: String
    $NOTI_CONTENT: String
    $WRITER: String
  ) {
    onCreateSeryNoti(
      REGDATE: $REGDATE
      USEFLAG: $USEFLAG
      NOTI_TITLE: $NOTI_TITLE
      NOTI_CONTENT: $NOTI_CONTENT
      WRITER: $WRITER
    ) {
      REGDATE
      USEFLAG
      NOTI_TITLE
      NOTI_CONTENT
      WRITER
      UPDATE_DATE
      UPDATE_WRITER
      ADDFILE
      NOTI_TYPE
      NOTI_BUTTON_NAME
      NOTI_BUTTON_LINK
      NOTI_BUTTON_LINK2
    }
  }
`;
export const onUpdateSeryNoti = /* GraphQL */ `
  subscription OnUpdateSeryNoti(
    $REGDATE: String
    $USEFLAG: String
    $NOTI_TITLE: String
    $NOTI_CONTENT: String
    $WRITER: String
  ) {
    onUpdateSeryNoti(
      REGDATE: $REGDATE
      USEFLAG: $USEFLAG
      NOTI_TITLE: $NOTI_TITLE
      NOTI_CONTENT: $NOTI_CONTENT
      WRITER: $WRITER
    ) {
      REGDATE
      USEFLAG
      NOTI_TITLE
      NOTI_CONTENT
      WRITER
      UPDATE_DATE
      UPDATE_WRITER
      ADDFILE
      NOTI_TYPE
      NOTI_BUTTON_NAME
      NOTI_BUTTON_LINK
      NOTI_BUTTON_LINK2
    }
  }
`;
export const onDeleteSeryNoti = /* GraphQL */ `
  subscription OnDeleteSeryNoti(
    $REGDATE: String
    $USEFLAG: String
    $NOTI_TITLE: String
    $NOTI_CONTENT: String
    $WRITER: String
  ) {
    onDeleteSeryNoti(
      REGDATE: $REGDATE
      USEFLAG: $USEFLAG
      NOTI_TITLE: $NOTI_TITLE
      NOTI_CONTENT: $NOTI_CONTENT
      WRITER: $WRITER
    ) {
      REGDATE
      USEFLAG
      NOTI_TITLE
      NOTI_CONTENT
      WRITER
      UPDATE_DATE
      UPDATE_WRITER
      ADDFILE
      NOTI_TYPE
      NOTI_BUTTON_NAME
      NOTI_BUTTON_LINK
      NOTI_BUTTON_LINK2
    }
  }
`;
export const onCreateTeryRecipe = /* GraphQL */ `
  subscription OnCreateTeryRecipe($regDate: String, $youtube_id: String) {
    onCreateTeryRecipe(regDate: $regDate, youtube_id: $youtube_id) {
      regDate
      youtube_id
      contents
      tag
      title
      useFlag
      views
    }
  }
`;
export const onUpdateTeryRecipe = /* GraphQL */ `
  subscription OnUpdateTeryRecipe($regDate: String, $youtube_id: String) {
    onUpdateTeryRecipe(regDate: $regDate, youtube_id: $youtube_id) {
      regDate
      youtube_id
      contents
      tag
      title
      useFlag
      views
    }
  }
`;
export const onUpdateTeryRecipeUseFlag = /* GraphQL */ `
  subscription OnUpdateTeryRecipeUseFlag($useFlag: Int) {
    onUpdateTeryRecipeUseFlag(useFlag: $useFlag) {
      regDate
      youtube_id
      contents
      tag
      title
      useFlag
      views
    }
  }
`;
export const onDeleteTeryRecipe = /* GraphQL */ `
  subscription OnDeleteTeryRecipe($regDate: String, $youtube_id: String) {
    onDeleteTeryRecipe(regDate: $regDate, youtube_id: $youtube_id) {
      regDate
      youtube_id
      contents
      tag
      title
      useFlag
      views
    }
  }
`;
export const onCreateTeryRecipeRank = /* GraphQL */ `
  subscription OnCreateTeryRecipeRank($searchWord: String) {
    onCreateTeryRecipeRank(searchWord: $searchWord) {
      searchWord
      searchCount
    }
  }
`;
export const onUpdateTeryRecipeRank = /* GraphQL */ `
  subscription OnUpdateTeryRecipeRank($searchWord: String) {
    onUpdateTeryRecipeRank(searchWord: $searchWord) {
      searchWord
      searchCount
    }
  }
`;
export const onDeleteTeryRecipeRank = /* GraphQL */ `
  subscription OnDeleteTeryRecipeRank($searchWord: String) {
    onDeleteTeryRecipeRank(searchWord: $searchWord) {
      searchWord
      searchCount
    }
  }
`;
export const onCreateTeryRecipeCategory = /* GraphQL */ `
  subscription OnCreateTeryRecipeCategory($regDate: String) {
    onCreateTeryRecipeCategory(regDate: $regDate) {
      regDate
      data
    }
  }
`;
export const onUpdateTeryRecipeCategory = /* GraphQL */ `
  subscription OnUpdateTeryRecipeCategory($regDate: String) {
    onUpdateTeryRecipeCategory(regDate: $regDate) {
      regDate
      data
    }
  }
`;
export const onDeleteTeryRecipeCategory = /* GraphQL */ `
  subscription OnDeleteTeryRecipeCategory($regDate: String) {
    onDeleteTeryRecipeCategory(regDate: $regDate) {
      regDate
      data
    }
  }
`;
export const onCreateStoreProductComment = /* GraphQL */ `
  subscription OnCreateStoreProductComment(
    $storeSeq: String
    $commentType: Int
  ) {
    onCreateStoreProductComment(
      storeSeq: $storeSeq
      commentType: $commentType
    ) {
      storeProductSeq
      regDate
      userSeq
      userImageUrl
      userName
      storeSeq
      depth
      memo
      commentType
      commentHead
      isRead
    }
  }
`;
export const onUpdateStoreProductComment = /* GraphQL */ `
  subscription OnUpdateStoreProductComment($storeProductSeq: String) {
    onUpdateStoreProductComment(storeProductSeq: $storeProductSeq) {
      storeProductSeq
      regDate
      userSeq
      userImageUrl
      userName
      storeSeq
      depth
      memo
      commentType
      commentHead
      isRead
    }
  }
`;
export const onDeleteStoreProductComment = /* GraphQL */ `
  subscription OnDeleteStoreProductComment($storeProductSeq: String) {
    onDeleteStoreProductComment(storeProductSeq: $storeProductSeq) {
      storeProductSeq
      regDate
      userSeq
      userImageUrl
      userName
      storeSeq
      depth
      memo
      commentType
      commentHead
      isRead
    }
  }
`;
export const onCreateStoreQnaInfoTable = /* GraphQL */ `
  subscription OnCreateStoreQnaInfoTable($type: String, $storeSeq: String) {
    onCreateStoreQnaInfoTable(type: $type, storeSeq: $storeSeq) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const onCreateStoreQnaInfoTable2 = /* GraphQL */ `
  subscription OnCreateStoreQnaInfoTable2(
    $roomType: String
    $storeSeq: String
  ) {
    onCreateStoreQnaInfoTable2(roomType: $roomType, storeSeq: $storeSeq) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const onUpdateStoreQnaInfoTable = /* GraphQL */ `
  subscription OnUpdateStoreQnaInfoTable($sK: String, $storeSeq: String) {
    onUpdateStoreQnaInfoTable(sK: $sK, storeSeq: $storeSeq) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const onUpdateNumberParticipants = /* GraphQL */ `
  subscription OnUpdateNumberParticipants($sK: String, $storeSeq: String) {
    onUpdateNumberParticipants(sK: $sK, storeSeq: $storeSeq) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const onDeleteStoreQnaInfoTable = /* GraphQL */ `
  subscription OnDeleteStoreQnaInfoTable($sK: String, $storeSeq: String) {
    onDeleteStoreQnaInfoTable(sK: $sK, storeSeq: $storeSeq) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const onCreateUpdateCheck = /* GraphQL */ `
  subscription OnCreateUpdateCheck(
    $type: String
    $version: String
    $coercionFlag: Boolean
    $regDate: String
  ) {
    onCreateUpdateCheck(
      type: $type
      version: $version
      coercionFlag: $coercionFlag
      regDate: $regDate
    ) {
      type
      version
      coercionFlag
      regDate
      updateUrl
    }
  }
`;
export const onUpdateUpdateCheck = /* GraphQL */ `
  subscription OnUpdateUpdateCheck(
    $type: String
    $version: String
    $coercionFlag: Boolean
    $regDate: String
  ) {
    onUpdateUpdateCheck(
      type: $type
      version: $version
      coercionFlag: $coercionFlag
      regDate: $regDate
    ) {
      type
      version
      coercionFlag
      regDate
      updateUrl
    }
  }
`;
export const onDeleteUpdateCheck = /* GraphQL */ `
  subscription OnDeleteUpdateCheck(
    $type: String
    $version: String
    $coercionFlag: Boolean
    $regDate: String
  ) {
    onDeleteUpdateCheck(
      type: $type
      version: $version
      coercionFlag: $coercionFlag
      regDate: $regDate
    ) {
      type
      version
      coercionFlag
      regDate
      updateUrl
    }
  }
`;
export const onCreateTeryMarketNoti = /* GraphQL */ `
  subscription OnCreateTeryMarketNoti($storeSeq: String) {
    onCreateTeryMarketNoti(storeSeq: $storeSeq) {
      orderSeq
      storeSeq
      status
    }
  }
`;
export const onUpdateTeryMarketNoti = /* GraphQL */ `
  subscription OnUpdateTeryMarketNoti($storeSeq: String) {
    onUpdateTeryMarketNoti(storeSeq: $storeSeq) {
      orderSeq
      storeSeq
      status
    }
  }
`;
export const onDeleteTeryMarketNoti = /* GraphQL */ `
  subscription OnDeleteTeryMarketNoti(
    $orderSeq: Int
    $storeSeq: String
    $status: String
  ) {
    onDeleteTeryMarketNoti(
      orderSeq: $orderSeq
      storeSeq: $storeSeq
      status: $status
    ) {
      orderSeq
      storeSeq
      status
    }
  }
`;
export const onCreateBooking = /* GraphQL */ `
  subscription OnCreateBooking($STORE_SEQ: String) {
    onCreateBooking(STORE_SEQ: $STORE_SEQ) {
      booking_idx
      product_fk
      STAFF_FK
      NAME
      STORE_SEQ
      PHONE_NUMBER
      BOOKING_DATE
      START_TIME
      END_TIME
      MEMO
      ETC
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/subscriptions.js